var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/*
 * [CLAIMS_CONTEXT]
 * purpose: Renders the "indemnisation/aucun-dommage" step of the declaration flow, which is displayed when the claim is not covered due to no damages.
 * touches: behavior, front-end, CI
 * invariants: The page should display the title, illustration, and paragraphs based on settings. The exit button and case number visibility are configurable and fallback to default values when settings are not provided.
 * inputs: selfCareSettings from Saltcorn (via settings store)
 * outputs: renders the page with the appropriate title, illustration, and paragraphs based on the settings
 * see: docs/self-care-settings/pages/compensationNoDamages.md
 */
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { createDefu } from 'defu';
import ParagraphsWithIcon from '@declaration/components/ParagraphsWithIcon.vue';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
const settings = namespace('settings');
// Custom defu function to replace arrays instead of merging them
const defu = createDefu((object, key, value) => {
    if (Array.isArray(object[key]) && Array.isArray(value)) {
        return true;
    }
});
const DEFAULT_ILLUSTRATION = 'documents/checklist';
let CompensationNoDamages = class CompensationNoDamages extends Vue {
    get pageSettings() {
        var _a, _b, _c;
        const frontendSettings = this.setting('selfCareSettings');
        return defu((_c = (_b = (_a = frontendSettings === null || frontendSettings === void 0 ? void 0 : frontendSettings.declaration) === null || _a === void 0 ? void 0 : _a.pages) === null || _b === void 0 ? void 0 : _b.compensationNoDamages) !== null && _c !== void 0 ? _c : {}, {
            illustration: DEFAULT_ILLUSTRATION,
            paragraphs: [['compensation.not_covered.no_damages.description']],
            quit: true,
            displayCaseNumber: false,
        });
    }
    get title() {
        return this.$tc('compensation.not_covered.no_damages.title');
    }
    get illustration() {
        try {
            return require(`~/assets/images/${this.pageSettings.illustration}.svg`);
        }
        catch (_a) {
            return require(`~/assets/images/${DEFAULT_ILLUSTRATION}.svg`);
        }
    }
    get contents() {
        return this.pageSettings.paragraphs.map((paragraph) => {
            const [key, icon] = Array.isArray(paragraph) ? paragraph : [paragraph.key, paragraph.icon];
            return {
                html: this.$tc(key),
                icon,
            };
        });
    }
    get continuation() {
        return this.pageSettings.quit ? 'quit' : null;
    }
};
__decorate([
    settings.Getter('setting')
], CompensationNoDamages.prototype, "setting", void 0);
CompensationNoDamages = __decorate([
    Component({
        components: {
            ParagraphsWithIcon,
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.compensation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            goBack: null,
        },
    })
], CompensationNoDamages);
export default CompensationNoDamages;
